import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/** Small inline "info" icon that reveals a hint on hover/focus/tap. */
export function InfoHint({ text, testId }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="More info"
            data-testid={testId}
            className="ml-1 inline-flex items-center text-muted-foreground hover:text-foreground focus:outline-none"
            onClick={(e) => e.preventDefault()}
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-left">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
